import * as Adaptive from "adaptivecards";
import { TypedCardElementPeer, PropertySheet, PropertySheetCategory, StringPropertyEditor } from "adaptivecards-designer";
import { removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";
import { ICustomProperty } from "../../../shared/interfaces/customproperties.interface";
import { CustomPropertyBase } from "./CustomPropertyBase";
import { getPropertyEditorInstance, PropertyKeys } from "../Pickers/PickerBase";
export class TimeProperty extends CustomPropertyBase {
    static JsonTypeName;
    static ElementId;
    static defaultLabel;
    static customPropertyData: ICustomProperty;

    constructor(paramType, paramCustomPropertyData: ICustomProperty) {
        
        TimeProperty.JsonTypeName = paramType ?? TimeProperty.JsonTypeName;
        TimeProperty.ElementId = paramCustomPropertyData?.PropertyId ?? TimeProperty.ElementId;
        TimeProperty.defaultLabel = paramCustomPropertyData?.Name ?? TimeProperty.defaultLabel;
        TimeProperty.customPropertyData = paramCustomPropertyData ?? TimeProperty.customPropertyData;
        
        super();
    }

    internalRender(): HTMLElement | undefined {
        if((this?.id ?? "").length == 0)
            this.id = TimeProperty.ElementId;

        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = TimeProperty.defaultLabel;

        if((this?.dataType ?? "").length == 0)
            this.dataType = TimeProperty.customPropertyData?.DataType ?? "";

        this.requireField ??= TimeProperty.customPropertyData?.IsRequired ?? false;

        this.errorMessage ??= TimeProperty.customPropertyData?.ErrorMessage ?? "";

        return super.internalRender();
    }


    getJsonTypeName(): string {
        return TimeProperty.JsonTypeName;
    }
}

export class TimePropertyPeer extends TypedCardElementPeer<TimeProperty> {
    static readonly displayLabelProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "displayLabel", "Label", false);
    static requireFieldProperty = getPropertyEditorInstance(TimeProperty.ElementId, PropertyKeys.requireField);
    static readonly requiredMessageProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "errorMessage", "Error Message", false);

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);

        propertySheet.add(
            defaultCategory,
            TimePropertyPeer.idProperty,
            TimePropertyPeer.displayLabelProperty
        );

        propertySheet.add(
            "Validation",            
            TimePropertyPeer.requireFieldProperty,
            TimePropertyPeer.requiredMessageProperty
        );
    }
}